{
  "orderList": {
    "createdTimeHeader": "Created",
    "orderedToHeader": "User",
    "statusHeader": "Status",
    "noOrdersText": "No orders",
    "errorText": "Fetching orders failed",
    "statuses": {
      "approved": "Approved",
      "delivered": "Delivered",
      "pendingApproval": "Pending approval",
      "financingDeclined": "Financing declined",
      "approvalDeclined": "Approval declined",
      "cannotBeProcessed": "Cannot be processed",
      "cancelled": "Cancelled",
      "returned": "Returned",
      "processingOrder": "Processing order",
      "discarded": "Discarded",
      "draft": "Draft"
    },
    "orderIdScope": "Order Id",
    "coltDeliveryIdScope": "COLT delivery Id",
    "findByOrderIdOrByColtDeliveryIdLabel": "Find order by order id or COLT delivery id",
    "searchPlaceholder": "Search ...",
    "orderIdHelperText": "Search for an order based on full order id",
    "coltDeliveryIdHelperText": "Search for an order based on full COLT delivery id",
    "noOrdersFoundByOrderIdErrorText": "No orders found with the given order id",
    "noOrdersFoundByColtDeliveryIdErrorText": "No orders found with the given COLT delivery id",
    "orderForOrganization": "Order device for organization",
    "orderForOrganizationInitError": "Failed to start order device for organization process"
  },
  "orderDetails": {
    "orderId": "Order id",
    "approvalChain": "Approval chain",
    "price": "Price",
    "leasePeriod": "Agreement period",
    "hardware": "Hardware",
    "services": "Services",
    "insurance": "Insurance",
    "user": "User",
    "purchaser": "Purchaser",
    "delivery": "Delivery",
    "devicesInUse": "Devices in use / end date",
    "previousOrders": "Previous orders / status",
    "month": "month",
    "months": "months",
    "includingVat": "incl. VAT",
    "excludingVat": "excl. VAT",
    "fetchError": "Fetching order details data failed",
    "approvalStepStatuses": {
      "pending": "Pending approval",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "countries": {
      "Finland": "Finland",
      "Norway": "Norway",
      "Sweden": "Sweden"
    },
    "orderCancelButton": "Cancel order",
    "orderCancelledTitle": "Order cancelled",
    "orderCancelledText": "The order has been cancelled. Please refresh the page to see updated status.",
    "orderCancelErrorTitle": "Order cancellation failed",
    "orderCancelErrorText": "Please try again later",
    "orderRestartButton": "Restart processing",
    "orderRestartedTitle": "Attempting to restart processing",
    "orderRestartedText": "Please check back again later",
    "orderRestartErrorTitle": "Attempt to restart order processing failed",
    "orderRestartErrorText": "Please try again later",
    "orderHistoryButton": "Show order history",
    "orderHistoryTitle": "Order history",
    "customerSupportName": "Customer Support",
    "approvalStatuses": {
      "approved": "Approved",
      "autoApproved": "Auto approved",
      "notneeded": "Approval not needed",
      "pending": "Pending approval",
      "rejected": "Rejected"
    },
    "coltOrderId": "COLT order id",
    "coltHardwareDeliveryId": "COLT hardware delivery id"
  }
}
